
import dayjs from 'dayjs';

/**
 * Formats a date string (YYYY-MM-DD or ISO) to MM-DD-YYYY.
 * @param dateStr - The input date string.
 * @returns The formatted date string in MM-DD-YYYY format.
 */
export function formatDate(dateStr: string, format: string = 'MMM DD, YYYY'): string {
	return dayjs(dateStr).format(format);
}

/**
 * Formats a date string (any parseable format) to YYYY-MM-DD for API usage.
 * @param dateStr - The input date string.
 * @returns The formatted date string in YYYY-MM-DD format.
 */
export function formatToApiDate(dateStr: string): string {
	return dayjs(dateStr).format('YYYY-MM-DD');
}